"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GlobalThemeComponent", {
  enumerable: true,
  get: function get() {
    return _themesComponent["default"];
  }
});
Object.defineProperty(exports, "defaultDarkColour", {
  enumerable: true,
  get: function get() {
    return _themesDefaultValues.defaultDarkColour;
  }
});
Object.defineProperty(exports, "defaultLightColour", {
  enumerable: true,
  get: function get() {
    return _themesDefaultValues.defaultLightColour;
  }
});
Object.defineProperty(exports, "defaultMidColour", {
  enumerable: true,
  get: function get() {
    return _themesDefaultValues.defaultMidColour;
  }
});
Object.defineProperty(exports, "themesConfig", {
  enumerable: true,
  get: function get() {
    return _themesConfig.themesConfig;
  }
});
var _themesComponent = _interopRequireDefault(require("./themes-component"));
var _themesConfig = require("./themes-config");
var _themesDefaultValues = require("./themes-default-values");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}